import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50d4a1fb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=50d4a1fb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4a1fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d4a1fb')) {
      api.createRecord('50d4a1fb', component.options)
    } else {
      api.reload('50d4a1fb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50d4a1fb&scoped=true", function () {
      api.rerender('50d4a1fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/loadingDocument/index.vue"
export default component.exports